<script setup>
import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net-bs5";
import DataTablesButtons from "datatables.net-buttons-bs5";
import DataTablesSelect from "datatables.net-select-bs5";
import "datatables.net-buttons/js/buttons.html5";

import useUsersTable from "@/scripts/Users/UsersTable";
import EditUserModal from "./EditUserModal.vue";

DataTable.use(DataTablesCore);
DataTable.use(DataTablesButtons);
DataTable.use(DataTablesSelect);

const {
  columns,
  tableData,
  permissions,
  tableOptions,
  showEditModal,
  selectedUser,
  closeEditModal,
} = useUsersTable();
</script>

<template>
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">MANAGE USERS</h3>
    </div>
    <div class="table-responsive">
      <div class="card-body">
        <DataTable
          :data="tableData"
          :columns="columns"
          :options="tableOptions"
          class="table table-hover table-spacing"
          width="100%"
        >
        </DataTable>
      </div>
    </div>
    <EditUserModal
      :permissions="permissions"
      :user="selectedUser"
      v-if="showEditModal"
      @closeEditModal="closeEditModal"
    />
  </div>
</template>
